import { Action } from '@ngrx/store';

export enum PhotoUploadActionTypes {
  PhotoUploadLoad = '[Photo Upload] Load',
  PhotoUploadLoadSuccess = '[Photo Upload] Load Success',
  PhotoUploadLoadFail = '[Photo Upload] Load Fail'
}

export class PhotoUploadLoad implements Action {
  readonly type = PhotoUploadActionTypes.PhotoUploadLoad;
  constructor(public payload: string) {}
}

export class PhotoUploadLoadSuccess implements Action {
  readonly type = PhotoUploadActionTypes.PhotoUploadLoadSuccess;
  constructor(public payload: any) {}
}

export class PhotoUploadLoadFail implements Action {
  readonly type = PhotoUploadActionTypes.PhotoUploadLoadFail;
  constructor(public payload?: any) {}
}

export type PhotoUploadAction = PhotoUploadLoad | PhotoUploadLoadSuccess | PhotoUploadLoadFail;

export const fromPhotoUploadActions = {
  PhotoUploadLoad,
  PhotoUploadLoadSuccess,
  PhotoUploadLoadFail
};
